
<template>
  <div v-if="hasDailyVerse" class="employee-grid-profile" :style="{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(${thumbnail})`,
    position: 'relative'
  }">

    <div class="profile-head">
      <div class="dep-name">
        <h5 :class="{ 'active': isToday, 'inactive': !isToday }">{{ getDateString(date) }}</h5>
      </div>
      <div class="profile-head-action">
        <div class="dropdown profile-action">
          <a href="javascript:void(0);" class="action-icon dropdown-toggle" data-bs-toggle="dropdown"
             aria-expanded="false">
            <vue-feather type="more-vertical" class=""></vue-feather>
          </a>
          <ul class="dropdown-menu">
<!--            <li>-->
<!--              <a class="dropdown-item" @click="copyDailyVerse()">-->
<!--                <vue-feather type="edit" class="info-img"></vue-feather>-->
<!--                Copy-->
<!--              </a>-->
<!--            </li>-->
            <li>
              <router-link class="dropdown-item" :to="`/dailyVerse/edit/${encodedData}`">
                <vue-feather type="edit" class="info-img"></vue-feather>
                Edit
              </router-link>
            </li>
            <li>
              <a @click="deleteDailyVerse(dailyVerse)" href="javascript:void(0);"
                 class="dropdown-item confirm-text mb-0"><vue-feather type="trash-2"
                                                                      class="info-img"></vue-feather>Delete</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="profile-info department-profile-info" :style="{ cursor: 'pointer' }" @click="">
      <h4 class="devotion-title">{{ dailyVerse.book }} {{ dailyVerse.chapter}}:{{dailyVerse.verse}}</h4>
    </div>
    <ul class="team-members position-absolute " style="bottom: 10px">
      <li>Total Like(s): {{ dailyVerse?.analysis?.likes }}</li>
    </ul>
  </div>
  <div v-else class="employee-grid-profile" :style="{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))`,
  }">
    <div class="profile-head">
      <div class="dep-name">
        <h5 :class="{ 'active': isToday, 'inactive': !isToday }">{{ getDateString(date) }}</h5>
      </div>
    </div>
    <div class="profile-info department-profile-info devotion-title pointer">
      <router-link :to="`/dailyVerse/add/${encodedData}`">
        <h4>No Daily Verse Added</h4>
        <i><vue-feather type="plus" size="10"></vue-feather> Click to Add</i>
      </router-link>
    </div>
  </div>


</template>

<script setup>
import { dateIsToday } from "@/utils/date";
import { computed } from "vue";
import { encodeUrlData } from "../utils/data";
import { useDailyVerseStore } from "@/store/dailyVerseStore";
import { notification } from "ant-design-vue";

const props = defineProps({
  dailyVerse: { type: Object, default: () => ({}) },
  date: String,
  type: String
});

const emit = defineEmits(["dailyVerseCopied"]);

const dailyVerseStore = useDailyVerseStore();

const hasDailyVerse = computed(() => Object.keys(props.dailyVerse || {}).length > 0);
const dailyVerse = computed(() => props.dailyVerse);

const thumbnail = computed(() =>
    props.dailyVerse?.thumbnail_url ?? props.dailyVerse?.media?.url ?? "https://images.unsplash.com/photo-1490730141103-6cac27aaab94?q=80"
);

const isToday = computed(() => dateIsToday(props.date));

// const encodedData = computed(() => encodeUrlData( props.date, props.dailyVerse?.id));
const encodedData = computed(() => {
  if (!props.date) return ""; // prevent undefined
  return encodeUrlData(props.date, props.dailyVerse?.id || null);
});

function getDateString(dateString) {
  const date = new Date(dateString);
  const day = date.getDate();
  const weekday = date.toLocaleString("en-us", { weekday: "long" });
  const suffix = (day >= 11 && day <= 13) ? "th" : ["st","nd","rd"][day % 10 - 1] || "th";
  return `${day}${suffix} - ${weekday}`;
}

async function deleteDailyVerse(dailyVerse) {
  await dailyVerseStore.deleteDailyVerse(dailyVerse.id, dailyVerse);
}

function copyDailyVerse() {
  const verse = { ...props.dailyVerse };
  dailyVerseStore.copiedDailyVerse = verse;
  emit("dailyVerseCopied", verse);
  notification.success({ message: "Daily Verse copied successfully" });
}
</script>

<style>
.employee-grid-profile {
  height: 175px;
  /*width: 181.6px; */
  background-size: cover;
  background-color: transparent;
}

.employee-grid-profile * {
  color: #ffffff;
}

.pointer {
  cursor: pointer;
}
</style>






